import { defineComponent as i, useSlots as r, openBlock as o, createElementBlock as s, normalizeClass as d, createElementVNode as t, renderSlot as a, unref as b, Fragment as p, createCommentVNode as u, createVNode as m } from "vue";
import c from "./components/icons/IconChevronDown.js";
const f = ["arial-label", "title", "tabindex", "disabled"], h = /* @__PURE__ */ t("span", { class: "px-2" }, "–", -1), g = { class: "text-pink" }, B = /* @__PURE__ */ i({
  __name: "BulkDiscountButton",
  props: {
    disabled: { type: Boolean, default: !1 },
    label: { default: void 0 },
    tabindex: { default: void 0 }
  },
  emits: ["click"],
  setup(k) {
    const n = r();
    return (e, l) => (o(), s("button", {
      class: d(["flex w-full items-center justify-between gap-0.5 rounded-md border border-gray-300 px-4 py-4 text-left text-sm text-black transition-colors md:py-4 lg:px-5 lg:text-base", {
        "cursor-pointer hover:border-gray-400": !e.disabled
      }]),
      "arial-label": e.label,
      title: e.label,
      tabindex: e.tabindex,
      disabled: e.disabled,
      type: "button",
      onClick: l[0] || (l[0] = (x) => e.$emit("click"))
    }, [
      t("div", null, [
        a(e.$slots, "default"),
        b(n).highlight ? (o(), s(p, { key: 0 }, [
          h,
          t("span", g, [
            a(e.$slots, "highlight")
          ])
        ], 64)) : u("", !0)
      ]),
      m(c, { class: "shrink-0 text-xl" })
    ], 10, f));
  }
});
export {
  B as _
};
